import store from '../store/store';
const LessonSelect = () => import('@/view/v4/chineseScreen/LessonSelect');
const HP02 = () => import('@/view/v4/chineseScreen/HP02');
const HP03 = () => import('@/view/v4/chineseScreen/HP03');
const CTA01 = () => import('@/view/v4/chineseScreen/CTA01');
const CTA02 = () => import('@/view/v4/chineseScreen/CTA02');
const CTA04 = () => import('@/view/v4/chineseScreen/CTA04');
const CTA05 = () => import('@/view/v4/chineseScreen/CTA05');
const CTT01 = () => import('@/view/v4/chineseScreen/CTT01');
const CTT02 = () => import('@/view/v4/chineseScreen/CTT02');
const CTT04 = () => import('@/view/v4/chineseScreen/CTT04');
const IAM01 = () => import('@/view/v4/chineseScreen/IAM01');
const IAM05 = () => import('@/view/v4/chineseScreen/IAM05');
const IAM08 = () => import('@/view/v4/chineseScreen/IAM08');
const LKA01 = () => import('@/view/v4/chineseScreen/LKA01');
const LKI01 = () => import('@/view/v4/chineseScreen/LKI01');
const LKS01 = () => import('@/view/v4/chineseScreen/LKS01');
const LKT01 = () => import('@/view/v4/chineseScreen/LKT01');
const LKT03 = () => import('@/view/v4/chineseScreen/LKT03');
const LKT04 = () => import('@/view/v4/chineseScreen/LKT04');
const CTV01 = () => import('@/view/v4/chineseScreen/CTV01');

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/userStatus']) {
    store.dispatch('template/setLangOption', true);
    next();
  } else {
    next('/homepage');
  }
};
export default [
  // chinese route template
  // {
  //     path: "/test/:id",
  //     name: "Test",
  //     component: Test,
  // },
  // {
  //     path: "/chinese",
  //     name: "Chinese",
  //     component: ChinesePreTest,
  //     beforeEnter: ifAuthenticated
  // },
  {
    path: '/v4/HP01/:id',
    name: 'HP01',
    component: LessonSelect,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/HP02/:id',
    name: 'HP02',
    component: HP02,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/HP03/:id',
    name: 'HP03',
    component: HP03,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CTA01/:id',
    name: 'CTA01',
    component: CTA01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CTA02/:id',
    name: 'CTA02',
    component: CTA02,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CTA04/:id',
    name: 'CTA04',
    component: CTA04,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CTA05/:id',
    name: 'CTA05',
    component: CTA05,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CTT01/:id',
    name: 'CTT01',
    component: CTT01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CTT02/:id',
    name: 'CTT02',
    component: CTT02,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CTT04/:id',
    name: 'CTT04',
    component: CTT04,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/IAM01/:id',
    name: 'IAM01',
    component: IAM01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/IAM05/:id',
    name: 'IAM05',
    component: IAM05,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/IAM08/:id',
    name: 'IAM08',
    component: IAM08,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LKA01/:id',
    name: 'LKA01',
    component: LKA01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LKI01/:id',
    name: 'LKI01',
    component: LKI01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LKS01/:id',
    name: 'LKS01',
    component: LKS01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LKT01/:id',
    name: 'LKT01',
    component: LKT01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LKT03/:id',
    name: 'LKT03',
    component: LKT03,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LKT04/:id',
    name: 'LKT04',
    component: LKT04,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CTV01/:id',
    name: 'CTV01',
    component: CTV01,
    beforeEnter: ifAuthenticated,
  },
];
